import {intRandom} from './_randNum';
const imagesLoaded = require('imagesloaded');

export function homeGallery() {
  const homeGallery = document.querySelector('.js-home-gallery');
  
  if(homeGallery && postsObj) {
    const obj = postsObj.posts;
    const randoms = [];
    const randomsNum = obj.length-1;
    let current = randomsNum;

    const homeGalleryChange = (isNext = true) => {
      const ww = window.document.documentElement.clientWidth;
      const homeGallery = document.querySelector('.js-home-gallery');

      if(isNext) {
        if(current == randomsNum) {
          current = 0;
        } else {
          current++;
        }
      } else {
        if(current == 0) {
          current = randomsNum;
        } else {
          current--;
        }
      }
      const currentNum = randoms[current];
      const currentObj = obj[currentNum];
      const ratio = currentObj.height/currentObj.width*100;

      // image container
      const imgContainer = document.createElement('div');
      imgContainer.classList.add('image-container');
      imgContainer.style.paddingBottom = `${ratio}%`;

      // img
      const img = document.createElement('img');
      img.setAttribute('src', currentObj.image);

      // link
      const a = document.createElement('a');
      a.classList.add('js-home-post-title');
      a.setAttribute('href', currentObj.permalink);
      a.setAttribute('target', '_self');
      a.innerHTML = `${currentObj.name}`;

      // post
      const el = document.createElement('div');
      el.classList.add('post');
      el.style.maxWidth = `${currentObj.width}px`;

      if (ww >= 768) {
        el.style.width = `${intRandom(minSize,maxSize)}%`;
      } else {
        el.style.width = `${intRandom(minSize*1.5,maxSize*1.25)}%`;
      }

      const posLeft = `${intRandom(-20,110)}`;
      const speed = intRandom(15000,30000);

      imagesLoaded(img, () => {
        el.style.left = `${posLeft}%`;
        el.style.animation = `gallery ${speed}ms linear 0ms 1`;
        imgContainer.style.animation = `galleryChild ${speed}ms linear 0ms 1`;
  
        imgContainer.appendChild(img);
        el.appendChild(imgContainer);
        homeGallery.appendChild(el);

        
        setTimeout(() => {
          el.classList.add('loaded');
        },0);

        setTimeout(() => {
          el.remove();
        },speed);
      });
    }

    const homeGalleryInit = () => {
      const min = 0;
      const max = obj.length-1;
      for(let i = min; i <= max; i++) {
        while(true) {
          var tmp = intRandom(min, max);
          if(!randoms.includes(tmp)) {
            randoms.push(tmp);
            break;
          }
        }
      }
      homeGalleryChange();
      let time = intRandom(minTiming,maxTiming);
      setInterval(() => {
        time = intRandom(minTiming,maxTiming);
        homeGalleryChange();
      },time);
    }
    
    homeGalleryInit();
  }
}